import { apis2, apis } from '.';
import http from './http';

export default class OpenProviderApi {
  static getProviderLicense () {
    return http.post(apis2.OpenProviderApi.providerLicenseCheck, { })
  }
}
